const accessorTreeStateReducer = (previousState, action) => {
  switch (action.type) {
    case "setData":
      if (previousState.name === "error" || previousState.binding !== action.binding) {
        return previousState;
      }
      return {
        name: "initialized",
        environment: previousState.environment,
        binding: previousState.binding,
        data: action.data
      };
    case "failWithError":
      if (previousState.binding !== action.binding) {
        return previousState;
      }
      return {
        name: "error",
        environment: previousState.environment,
        binding: previousState.binding,
        error: action.error
      };
    case "reset":
      return {
        name: "initializing",
        environment: action.environment,
        binding: action.binding
      };
  }
};
export {
  accessorTreeStateReducer
};
//# sourceMappingURL=accessorTreeStateReducer.js.map
